import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdWhatsAppMessageTemplatesCacheKeys: AllRouteEndpoints[] = [];
export const engagementAppGroupIdWhatsAppMessageTemplateId =
  "/engagement/:app_group_id/whats_app/message_template/:id";
